export * from './jatak.service';
export * from './jatakresolver.service';
